(function () {
    'use strict';

    angular.module('app.blogPostTag')
        .run(appRun);

    appRun.$inject = ['routerHelper'];

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'blogposttag',
                config: {
                    url: '/blogposttag',
                    title: 'Etiketler',
                    abstract: true,
                    templateUrl: 'app/blogPostTag/blogposttag.html'
                }
            },
            {
                state: 'blogposttag.list',
                config: {
                    templateUrl: 'app/blogPostTag/blogposttag.list.html',
                    controller: 'PostTagListController',
                    controllerAs: 'vm',
                    url: '/list',
                    title: 'Etiket Listesi',
                    settings: {
                        nav: 10,
                        name: 'blogposttag.list',
                        content: 'Etiket Listesi',
                        resource: 'menu.tags.list'
                    }
                }
            },
            {
                state: 'blogposttag.add',
                config: {
                    templateUrl: 'app/blogPostTag/blogposttag.add.html',
                    controller: 'PostTagsAddController',
                    controllerAs: 'vm',
                    url: '/add',
                    title: 'Etiket Ekle',
                    settings: {
                        topName: 'blogposttag.list',
                        resource: 'menu.tags.add'
                    }
                }
            },
            {
                state: 'blogposttag.edit',
                config: {
                    templateUrl: 'app/blogPostTag/blogposttag.edit.html',
                    controller: 'PostTagsEditController',
                    controllerAs: 'vm',
                    url: '/edit/:Id',
                    title: 'Etiket Düzenle',
                    settings: {
                        topName: 'blogposttag.list',
                        resource: 'menu.tags.edit'
                    }
                }
            },
            {
                state: 'blogposttag.detail',
                config: {
                    templateUrl: 'app/blogPostTag/blogposttag.detail.html',
                    controller: 'PostTagsDetailController',
                    controllerAs: 'vm',
                    url: '/detail/:Id',
                    title: 'Etiket Detay',
                    settings: {
                        topName: 'blogposttag.list',
                        resource: 'menu.tags.detail'
                    }
                }
            }
        ];
    }
})();